<template>
  <component
    :is="rootComponent"
    :class="[
      'relative flex h-[3.75rem] w-full cursor-pointer items-center justify-between p-3',
      inverted ? 'bg-primary' : 'bg-background',
    ]"
    :to="to"
    v-bind="componentProps"
  >
    <div class="flex h-full items-center justify-center">
      <slot name="icon">
        <div
          :class="[
            'size-8 rounded-lg p-1',
            inverted ? 'bg-primary-fg' : 'bg-primary',
          ]"
        >
          <component
            :is="icon"
            :class="[
              'size-full',
              inverted ? 'text-primary' : 'text-background',
            ]"
          />
        </div>
      </slot>
    </div>
    <div class="ml-3 flex-1">
      <p
        :class="[
          'line-clamp-1 text-left text-sm font-semibold',
          inverted ? 'text-primary-fg' : '',
        ]"
      >
        <slot name="label">
          {{ label }}
        </slot>
      </p>
      <p
        v-if="description || $slots.description"
        :class="[
          'line-clamp-1 text-left text-xs',
          inverted
            ? 'text-primary-fg/90'
            : 'text-background-fg/70',
        ]"
      >
        <slot name="description">
          {{ description }}
        </slot>
      </p>
    </div>
    <div
      class="ml-3 flex h-full items-center justify-center"
    >
      <IconChevronRight
        :class="[
          'size-6',
          inverted
            ? 'text-primary-fg/50'
            : 'text-background-fg/20',
        ]"
      />
    </div>
  </component>
</template>

<script setup lang="ts">
import type { Component } from "vue"
import type { RouteLocationRaw } from "vue-router"

const props = withDefaults(
  defineProps<{
    icon?: Component
    label?: string
    description?: string
    to?: RouteLocationRaw
    inverted?: boolean
  }>(),
  {
    label: "",
    icon: undefined,
    description: "",
    to: undefined,
    inverted: false,
  }
)

const rootComponent = computed(() =>
  props.to ? "RouterLink" : "button"
)

const componentProps = computed(() =>
  rootComponent.value === "button" ? { type: "button" } : {}
)
</script>
